import React from "react";
import "./Title.css";

export default function Title({ data }) {
  return <h3 className="title">{data}</h3>;
}
